// Entry point: loads every part of the app in order, then starts it. Built into public/app.js by scripts/build.mjs.
import './core/react.js';
import './core/theme.js';
import './core/fx.js';
import './core/project.js';
import './ui/table-editor.js';
import './ui/widgets.js';
import './ui/icons.js';
import './shell/login.js';
import './shell/sidebar.js';
import './shell/topbar.js';
import './pages/dashboard.js';
import './pages/budget.js';
import './pages/invoices.js';
import './pages/estimate-pdf.js';
import './pages/quotes.js';
import './pages/internal-pl.js';
import './pages/estimate.js';
import './pages/settings.js';
import './pages/crew.js';
import './pages/resourcing.js';
import './pages/files.js';
import './pages/deliveries.js';
import './pages/suppliers.js';
import './pages/system.js';
import './pages/security.js';
import './pages/activity.js';
import './core/excel.js';
import './pages/project.js';
import './pages/team.js';
import './core/util.js';
import './core/api.js';
import './core/sync.js';
import './shell/modules.js';
import './shell/app.js';
import { App } from './shell/app.js';

ReactDOM.createRoot(document.getElementById('root')).render(React.createElement(App, null));

